<!--
 * @Author: lan.h
 * @Date: 2022-02-21 15:05:16
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-31 15:32:00
 * @Description: 推荐赛道
-->
<template>
  <div class="track">
    <div class="mode-title">
      <span class="title-p">推荐赛道</span>
      <div class="comp-src-name">推荐赛道数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click="haddleApplyTry2(32)"> 提供支持</div>
    </div>
    <div class="track-content" :style="{height: (track.length > 3 ? height : 170) + 'px'}">
      <a class="block" :class="'block' + index" v-for="item, index in track" :key="index" @click="toTrack" :href="$store.state.index_path + '/trackDetail?track=' + item.id" target="_blank">
        <div class="num">0{{index+1}}</div>
        <img :src="$store.state.static_img_url+'pic/vcbeat/track.png'">
        <h2 :class="index < 3 ? 'over-p1' : 'over-p2'">{{item.name}}</h2>
        <div class="desc over-p3" v-if="index == 0" v-html="item.themeDesc"></div>
      </a>
    </div>
  </div>
</template>

<script>
import { recommendtrack } from '../../service'

export default {
  inject: ['haddleApplyTry2'],
  props: {
    height: {
      // 方块整体的高度
      default: 270
    },
    size : {
      // 推荐赛道的数量
      default: 6
    },
    pageType: {
      default: ''    //1首页 2文章详情
    }
  },
  data() {
    return {
      track: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await recommendtrack({
        size: this.size
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'track', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    toTrack() {
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧推荐赛道(赛道)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(推荐赛道)', '点击量'])
      }
      else if(this.pageType == '3') {
        _czc.push(['_trackEvent', '看赛道(新)', '右侧推荐赛道(赛道)', '点击量'])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.track
  &-content
    position relative
    margin-top 20px
    height 270px
    .block
      display inline-block
      position relative
      .num
        width 30px
        height 30px
        background-color rgba(#fff 0.3)
        font-size 14px
        color #FFFFFF
        font-weight 500
        line-height 30px
        text-align center
      img 
        position absolute
        bottom 0
        right 0
      h2 
        font-size 16px
        font-weight bold
        color #FFFFFF
        line-height 1
        margin 14px
      .desc
        font-size 13px
        font-weight 500
        color #FEFEFE
        line-height 18px
        margin 40px 14px 14px
        >>> p
        >>> span 
          color #FEFEFE !important
    .block0
      background #4599BC
      height 170px
      width 47.9768%
      img 
        width 70.48%
    .block1
      background #B9B3AB
      height 90px
      top 0
    .block2
      background #CA9B6D
      height 76px
      top 94px
    .block3
      background #596672
      position absolute
      top 174px
      left 0
      width 47.9768%
      height calc(100% - 174px)
      h2
        font-size 14px
      img 
        width 34.34%
    .block4
      background #449267
      left calc(47.9768% + 4px)
    .block5
      background #D5B095
      right 0
    .block1, .block2
      position absolute
      right 0
      width calc(49.6% + 4px)
      img 
        width 45.71%
    .block4, .block5
      position absolute
      top 174px
      width 24.8%
      height calc(100% - 174px)
      h2
        font-size 13px
        line-height 18px
      img 
        width 60%
</style>